import { requestUtil } from "../../apis";

export const apiGetLineLink = (params: any): any =>
  requestUtil("get", `/api/setting/list`, params, false);
